var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSpinner = function SvgSpinner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.065 1.698c.186-.693-.226-1.413-.936-1.529A13.053 13.053 0 002.196 5.777a12.98 12.98 0 00.496 15.137 13.042 13.042 0 006.555 4.526c2.606.788 5.392.743 7.971-.13a13.025 13.025 0 006.403-4.738 12.98 12.98 0 002.373-6.274c.072-.715-.518-1.298-1.238-1.298s-1.294.584-1.384 1.296a10.385 10.385 0 01-1.869 4.761 10.423 10.423 0 01-5.123 3.791 10.449 10.449 0 01-6.376.104 10.423 10.423 0 01-5.244-3.62 10.376 10.376 0 01-.397-12.109 10.42 10.42 0 014.995-3.957c1.63-.612 3.381-.804 5.093-.569.713.098 1.427-.305 1.614-.999z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpinner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spinner.88111467.svg";
export { ForwardRef as ReactComponent };